import { render, staticRenderFns } from "./CandidateDashboard.vue?vue&type=template&id=5575ecbe&scoped=true"
import script from "./CandidateDashboard.vue?vue&type=script&lang=ts"
export * from "./CandidateDashboard.vue?vue&type=script&lang=ts"
import style0 from "./CandidateDashboard.vue?vue&type=style&index=0&id=5575ecbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5575ecbe",
  null
  
)

export default component.exports